import { useApi } from '@/api';
import {
  ActivityCard,
  ExternalLinkIcon,
  KpiCard,
  LinkButton,
  Page,
  PageSkeleton
} from '@/components';
import UpgradeIcon from '@/components/icons/UpgradeIcon';
import UpgradeLogo from '@/components/icons/UpgradeLogo';
import { tokensMapping } from '@/utils/tokens';
import {
  ArrowRightIcon,
  EtherScanPictogram,
  Flex,
  Heading
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function MigrationsMKRSKYPage() {
  const [data, error] = useApi({
    url: '/migrations/mkr-sky/',
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Flex gap="2xs" alignItems="center">
            <UpgradeLogo size="3" />
            <Heading size="1">
              <Flex gap="xs" alignItems="center">
                MKR <ArrowRightIcon /> SKY
                <a
                  href={`https://etherscan.io/address/0xa1ea1ba18e88c381c724a75f23a130420c403f9a`}
                  target="_blank"
                  rel="noreferrer">
                  <EtherScanPictogram size="0" />
                </a>
              </Flex>
            </Heading>
          </Flex>
        }
        actions={
          <>
            <LinkButton
              to="https://app.sky.money/?widget=upgrade&source_token=MKR"
              target="_blank">
              <Flex
                gap="3xs"
                alignItems="center"
                style={{ whiteSpace: 'nowrap' }}>
                <UpgradeIcon size="1" /> Upgrade MKR to SKY
                <ExternalLinkIcon size="1" />
              </Flex>
            </LinkButton>
          </>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            variant="sky"
            title="SKY"
            data={data}
            field="sky_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '4',
                  currency: tokensMapping('SKY')
                }
              }
            }}
          />
          <KpiCard
            variant="mkr"
            title="MKR"
            data={data}
            field="mkr_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '4',
                  currency: tokensMapping('MKR')
                }
              }
            }}
          />
        </Flex>
        <HistoricTabs />
        <ActivityCard url={'/migrations/mkr-sky/activity/'} linkTo="activity" />
      </Page>
    );
  }
  return <PageSkeleton />;
}
